import React, {useState} from 'react';
import {Button, Card, CardActions, CardContent, Divider, Grid, Typography, } from '@mui/material';
import styles from 'styles/informacionDelCard';
import ElementoDelCard from 'components/card/ElementoDelCard';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { functions } from 'constantes';
import { Close, Delete, Edit } from '@mui/icons-material';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';

const DetalleCoberturaAsignada = ({titleDialog, openFullScreenDialog, handleClose, datosDelEspacioContratado, manejadorEliminarAsignacion, manejadorEdicionAsignacion}) => {
  const classes = styles();
  // console.log("datosDelEspacioContratado", datosDelEspacioContratado)
  const {datosDelMedio: {nivelCobertura, nombreMedio, tipoCandidatura, empresa, nombreMedioDeComunicacion}, start, title} = datosDelEspacioContratado;
  const [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

  const eliminarSeleccion = () => { setAlertaDeConfirmacion(true)}

  const cerrarAlertaDeConfirmacion = () => { setAlertaDeConfirmacion(false) }

  const manejarEliminarElemento = () => {
    setAlertaDeConfirmacion(false)
    manejadorEliminarAsignacion(datosDelEspacioContratado)
  }

  const editarSeleccion = () => { manejadorEdicionAsignacion(datosDelEspacioContratado) }

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={handleClose}
      title={titleDialog}
      fullscreen={false}
      maxWidth={"md"}
    >
    <Card className={classes.root}>
        <Typography className={classes.titleDetalle}> {tipoCandidatura || ""} - {nombreMedio || ""} - ({nivelCobertura?.name || ""}) </Typography>
        <CardContent>
          <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12} md={6}>
                <ElementoDelCard title={'Corporación:'} label={empresa?.empresa?.nombreEmpresa || ""}/>
                <ElementoDelCard title={'Nombre del medio:'} label={nombreMedioDeComunicacion || ""}/>
                {/* <ElementoDelCard title={'Descripción:'} label={espacioPublicitarioMedio || ""}/> */}
              </Grid>
              <Grid item xs={12} md={6}>
                  <ElementoDelCard title={'Cantidad asignada:'} label={title || ""}/>
                <ElementoDelCard title={'Fecha seleccionada:'} label={functions.FormatearFecha(start || "")}/>
                {/* <ElementoDelCard title={'¿Cedió está asignación a Presidencia?:'} label={cederAsignacion === 1 ? "SI" : "NO" || ""}/> */}
              </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button variant="contained" color="warning" className={classes.button} onClick={editarSeleccion}>
            <Edit />
            Editar selección
          </Button>
          <Button variant="contained" color="primary" className={classes.button} onClick={eliminarSeleccion}>
            <Delete />
            Eliminar selección
          </Button>
          <Button variant="contained" color="primary" className={classes.buttonCancel} onClick={handleClose}>
            <Close />
            Cancelar
          </Button>
        </CardActions>
        {alertaDeConfirmacion && (
          <ModalDeConfirmacion
              title={`¿Está seguro de eliminar ${title || ""} contratado(s) a ${nombreMedioDeComunicacion || ""} ?`} message={"No podrá revertir esta acción"}
              open={alertaDeConfirmacion}
              closeModal={cerrarAlertaDeConfirmacion}
              titleButton={"Sí, estoy seguro"}
              actionAdd={manejarEliminarElemento}
          />
          )}
    </Card>
    </DialogoPantallaCompleta>
  );
}

export default DetalleCoberturaAsignada;